<vi-page
  [sidenavs]="true"
  [sidenavMode]="sideSideNavMode"
  [footer]="true"
  [isWhiteBackground]="true"
>
  <app-callback-notification head></app-callback-notification>

  <vi-content body [contentWidth]="'100%'" layoutAlign="justify-start items-start" [gap]="'12px'">
    <ng-container
      main
      *ngrxLet="kanbanBoardStore.fetchingDashboardStatus$ as fetchingDashboardStatus"
    >
      <!-- Status notification -->
      <app-status-page></app-status-page>

      <!-- Links -->
      <app-kanban-installation-list-header></app-kanban-installation-list-header>
      <!-- Loader -->
      <vi-loader
        *ngIf="fetchingDashboardStatus.loading"
        [isLoading]="true"
        [message]="'+INSTALLATIONS.INSTALLATIONS.LOADING_MESSAGE' | translate"
      ></vi-loader>
      <!-- Columns -->
      <ng-container *ngIf="fetchingDashboardStatus.loaded">
        <app-kanban-installation-list-columns
          [columns]="kanbanBoardStore.columns$ | async"
        ></app-kanban-installation-list-columns>
      </ng-container>
      <!-- Error -->
      <vi-info-panel
        *ngIf="fetchingDashboardStatus.error"
        imageSrc="/assets/img/no-installation.png"
      >
        <div content class="flex flex-col gap-[16px] justify-start items-start">
          <h2 data-at-title-no-data class="panel-item flex-auto">
            {{ '+INSTALLATIONS.INSTALLATIONS.CONNECTION.NO_CONNECTION_HEADER' | translate }}
          </h2>
          <div data-at-content-no-data class="panel-item flex-auto">
            {{ '+INSTALLATIONS.INSTALLATIONS.CONNECTION.NO_CONNECTION' | translate }}
          </div>
          <button
            mat-raised-button
            color="primary"
            *ngIf="dataService.invitationsCount$ | async"
            gtm="onGoToPage"
            gtmAction="Invitations"
            gtmCategory="installationsOverview"
            [routerLink]="['/invitations']"
          >
            {{ '+INSTALLATIONS.INSTALLATIONS.CONNECTION.SEE_REQUESTS' | translate }} ({{
              dataService.invitationsCount$ | async
            }})
          </button>
        </div>
      </vi-info-panel>
    </ng-container>
  </vi-content>

  <vi-dsw-footer footer data-at-footer></vi-dsw-footer>
  <app-sidenav left-sidenav></app-sidenav>
</vi-page>
